module.exports = __webpack_public_path__ + "media/images/emblems/Wynau-coat_of_arms-3f3d13af44d7611c02fb68f2984c946e.svg";